(function () {
  'use strict';

  var config = window.__TURAPURA_META_FUNNEL_CONFIG__ || {};
  if (!config.pixelId || !/^\/bg(?:\/|$)/.test(window.location.pathname)) return;
  if (window.__TURAPURA_META_FUNNEL__) return;

  var ready = false;
  var loading = false;
  var queue = [];
  var lastCartEventAt = 0;
  var pixelBootstrapped = false;
  var retryTimer;
  var retryCount = 0;
  var privacyLoading = false;
  var pendingCart = null;
  var lastCheckoutKey = '';
  var lastCheckoutAt = 0;

  function eventId(prefix) {
    return prefix + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 12);
  }

  function ensurePrivacyApi() {
    if (privacyLoading || !window.Shopify || window.Shopify.customerPrivacy || typeof window.Shopify.loadFeatures !== 'function') return;
    privacyLoading = true;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
      privacyLoading = false;
      if (error) return;
      installPixel();
      trackProductView();
    });
  }

  function consentAllowed() {
    try {
      return Boolean(
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed() &&
        window.Shopify.customerPrivacy.marketingAllowed()
      );
    } catch (error) {
      return false;
    }
  }

  function installPixel() {
    if (loading || ready || !consentAllowed()) return;
    loading = true;

    if (typeof window.fbq === 'function' && !pixelBootstrapped) {
      ready = true;
      loading = false;
      while (queue.length) {
        var existingEvent = queue.shift();
        window.fbq('trackSingle', String(config.pixelId), existingEvent.name, existingEvent.params, existingEvent.options);
      }
      return;
    }

    if (!window.fbq) {
      var fbq = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      window.fbq = fbq;
      window._fbq = fbq;
    }

    if (!pixelBootstrapped) {
      window.fbq('init', String(config.pixelId));
      window.fbq('trackSingle', String(config.pixelId), 'PageView');
      pixelBootstrapped = true;
    }

    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onload = function () {
      ready = true;
      loading = false;
      if (retryTimer) window.clearInterval(retryTimer);
      if (!consentAllowed()) {
        queue = [];
        return;
      }
      while (queue.length) {
        var event = queue.shift();
        window.fbq('trackSingle', String(config.pixelId), event.name, event.params, event.options);
      }
    };
    script.onerror = function () {
      loading = false;
      script.remove();
    };
    document.head.appendChild(script);
  }

  function track(name, params, eventId) {
    if (!consentAllowed()) return;
    var event = {
      name: name,
      params: params || {},
      options: eventId ? { eventID: eventId } : undefined
    };
    if (ready && typeof window.fbq === 'function') {
      window.fbq('trackSingle', String(config.pixelId), event.name, event.params, event.options);
    } else {
      if (queue.length < 30) queue.push(event);
      installPixel();
    }
  }

  function getCart() {
    if (pendingCart) return pendingCart;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    pendingCart = fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; })
      .finally(function () { pendingCart = null; });
    return pendingCart;
  }

  function cartParams(cart) {
    if (!cart) return { currency: 'EUR' };
    return {
      currency: cart.currency || 'EUR',
      value: Number(cart.total_price || 0) / 100,
      content_type: 'product',
      content_ids: (cart.items || []).map(function (item) { return String(item.variant_id); }),
      contents: (cart.items || []).map(function (item) {
        return { id: String(item.variant_id), quantity: Number(item.quantity || 1) };
      }),
      num_items: Number(cart.item_count || 0)
    };
  }

  function trackCartEvent(name, prefix) {
    if (!consentAllowed()) return Promise.resolve(null);
    return getCart().then(function (cart) {
      if (!cart || !Number(cart.item_count)) return cart;
      if (name === 'InitiateCheckout') {
        var key = JSON.stringify(cartParams(cart));
        var now = Date.now();
        if (key === lastCheckoutKey && now - lastCheckoutAt < 30000) return cart;
        lastCheckoutKey = key;
        lastCheckoutAt = now;
      }
      track(name, cartParams(cart), eventId(prefix));
      return cart;
    });
  }

  var viewTracked = false;
  function trackProductView() {
    if (viewTracked || !consentAllowed() || !/^\/bg\/products\//.test(window.location.pathname)) return;
    viewTracked = true;
    track('ViewContent', {
      content_name: document.querySelector('h1') ? document.querySelector('h1').textContent.trim() : document.title,
      content_category: 'Skincare',
      content_type: 'product',
      currency: 'EUR'
    }, eventId('view'));
  }

  document.addEventListener('cart:item-added', function () {
    var now = Date.now();
    if (now - lastCartEventAt < 1200) return;
    lastCartEventAt = now;
    trackCartEvent('AddToCart', 'cart');
  });

  document.addEventListener('click', function (event) {
    var codButton = event.target.closest && event.target.closest('button.cod-buy-btn, [data-turapura-cod-checkout]');
    if (!codButton || codButton.disabled || codButton.getAttribute('aria-disabled') === 'true') return;
    trackCartEvent('InitiateCheckout', 'checkout');
  }, true);

  document.addEventListener('visitorConsentCollected', function () {
    if (!consentAllowed()) { queue = []; return; }
    installPixel();
    trackProductView();
  });
  document.addEventListener('DOMContentLoaded', function () {
    ensurePrivacyApi();
    installPixel();
    trackProductView();
  });
  window.addEventListener('online', function () {
    ensurePrivacyApi();
    installPixel();
    trackProductView();
  });
  retryTimer = window.setInterval(function () {
    retryCount += 1;
    if (ready || retryCount > 20 || (window.Shopify && window.Shopify.customerPrivacy && !consentAllowed())) {
      window.clearInterval(retryTimer);
      return;
    }
    ensurePrivacyApi();
    installPixel();
    trackProductView();
  }, 1500);
  ensurePrivacyApi();
  installPixel();
  trackProductView();

  window.__TURAPURA_META_FUNNEL__ = {
    pixelId: String(config.pixelId),
    track: track,
    get ready() { return ready; }
  };
})();
